import { styled } from 'stitches.config'

export const SubscriptionRoot = styled('div', {
  backgroundColor: '$tertiary-200',
  color: '$accent-black',
  px: '$3',
  paddingTop: '$9',
  paddingBottom: '$11',

  '@bp2': {
    px: '$15',
  },
})

export const Flex = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '$8',

  '& > *': {
    flex: 1,
  },

  '@bp2': {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
})

export const List = styled('ul', {
  listStyle: 'none',
})

export const Item = styled('li', {
  marginTop: '$4',

  '&:first-child': {
    marginTop: 0,
  },
})

export const Content = styled('div', {
  textAlign: 'center',

  '@bp2': {
    textAlign: 'initial',
  },
})
